module.exports = __webpack_public_path__ + "static/media/Group 28315.2260baca.svg";